import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/LoginPage.css"; // Assuming Signup uses the same CSS as Login
import { useAuth } from "../../contexts/AuthContext";

// Import your SVG file and logos (adjust paths if necessary)
import MarketingIllustration from "../../assets/TestingLogin.svg";
// TODO: Uncomment these imports when implementing OAuth
// import googleIcon from "../../assets/images/login/googleLogo.png";
// import linkedinIcon from "../../assets/images/login/linkedinLogo.png";
import skillMatchLogo from "../../assets/images/login/skillMatchLogo.svg";

const SignupPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const { register /* getGoogleLoginUrl, getLinkedinLoginUrl */ } = useAuth();
  const navigate = useNavigate();

  // Handle signup form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!email || !password || !confirmPassword) {
      setErrorMessage("Please fill in all fields");
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }
    if (password.length < 8) {
      setErrorMessage("Password must be at least 8 characters long");
      return;
    }

    setErrorMessage("");
    setSuccessMessage(""); // Clear previous success message on new attempt
    setIsLoading(true);

    try {
      await register(email, password);
      setSuccessMessage(
        "Registration successful! Please check your email to verify your account."
      );
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      setTimeout(() => {
        navigate("/login");
      }, 3000); // Redirect after 3 seconds
    } catch (error) {
      console.error("Registration error:", error);
      setErrorMessage(
        error.response?.data?.detail || "Registration failed. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // TODO: Uncomment and implement OAuth handlers when ready
  /*
  // Handle OAuth logins
  const handleGoogleLogin = () => {
    window.location.href = getGoogleLoginUrl();
  };

  const handleLinkedInLogin = () => {
    window.location.href = getLinkedinLoginUrl();
  };

  const handleTwitterLogin = () => {
    setErrorMessage("Twitter login is not available yet");
  };
  */

  return (
    <div className="login-container">
      {/* Left Section - Signup Form */}
      <div className="login-form-section">
        {/* Logo */}
        <div className="logo-container">
          <img
            src={skillMatchLogo}
            alt="SkillMatchAI Logo"
            className="logo-image"
          />
        </div>
        {/* Signup Form */}
        <div className="form-container">
          <h1 className="form-title">Create an account</h1>
          <p className="form-subtitle">Enter your details to sign up</p>

          {errorMessage && <div className="error-message">{errorMessage}</div>}
          {successMessage && (
            <div className="success-message">{successMessage}</div>
          )}

          {/* TODO: Uncomment Social Login Buttons when OAuth is implemented */}
          {/*
          <div className="social-login-buttons">
            <button
              className="social-button google"
              onClick={handleGoogleLogin}
              type="button"
            >
              <img src={googleIcon} alt="Google" className="social-icon" />
              <span>Google</span>
            </button>
            <button
              className="social-button linkedin"
              onClick={handleLinkedInLogin}
              type="button"
            >
              <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
              <span>LinkedIn</span>
            </button>
          </div>

          <div className="divider">
            <div className="divider-line"></div>
            <span className="divider-text">OR</span>
            <div className="divider-line"></div>
          </div>
          */}

          {/* Signup Form */}
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                placeholder="@youremail"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading || successMessage} // Disable if loading or success
              />
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                type="password"
                placeholder="Minimum 8 characters"
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                disabled={isLoading || successMessage} // Disable if loading or success
              />
            </div>

            <div className="form-group">
              <label className="form-label">Confirm Password</label>
              <input
                type="password"
                placeholder="••••••••••••••••••"
                className="form-input"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={8}
                disabled={isLoading || successMessage} // Disable if loading or success
              />
            </div>

            <button
              type="submit"
              className="signin-button"
              disabled={isLoading || successMessage} // Disable if loading or showing success
            >
              {isLoading ? "Creating Account..." : "Create Account"}
            </button>
          </form>

          <div className="signup-prompt">
            <span>Already have an account? </span>
            <a href="/login" className="signup-link">
              Sign In
            </a>
          </div>
        </div>
      </div>
      {/* Right Section - SVG Illustration */}
      <div className="marketing-section">
        <img
          src={MarketingIllustration}
          alt="SkillMatchAI marketing illustration"
          className="marketing-svg"
        />
      </div>
    </div>
  );
};

export default SignupPage;
